export default __webpack_public_path__ + "static/media/user-edit-icon.9edb7a3b.svg";